var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './casesItem.module.scss';
import { Icons } from 'src/ui/components/Icons/Icons';
import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { E_TOOLTIP_POSITION, Tooltip } from 'src/ui/components/ToolTip/Tooltip';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var CaseItem = function (props) {
    var _a;
    var i18n = props.i18n, content = props.content, isLocked = props.isLocked, onClick = props.onClick, lockedBy = props.lockedBy;
    var handleOnItemClick = function (e) {
        e.stopPropagation();
        if (onClick) {
            onClick();
        }
    };
    var handleTextCopy = function (e, textToCopy) {
        e.stopPropagation();
        navigator.clipboard.writeText(textToCopy);
    };
    var lockedTooltip = getPropsByKeyPath(i18n.components, 'tooltips.cases.lockBy').replace('${userName}', '');
    return (_jsxs("tr", __assign({ className: classNames(styles.caseItemWrapper, isLocked && styles.caseItemWrapperDisabled, (_a = {},
            _a[styles.caseItemWrapperClickable] = !!onClick,
            _a)), onClick: handleOnItemClick }, { children: [content.map(function (val, index) { return (_jsx("td", { children: _jsxs("span", __assign({ className: styles.cellItem }, { children: [_jsx("p", __assign({ style: val.style }, { children: val.text })), val.text && _jsx(Icons, { icon: E_ICONS.COPY, className: styles.image, onClick: function (e) { return handleTextCopy(e, val.text); } })] })) }, "".concat(val.text, "-").concat(index))); }), _jsx("td", __assign({ className: styles.caseItemArrow }, { children: isLocked ? (_jsxs(_Fragment, { children: [_jsxs(Tooltip, __assign({ position: E_TOOLTIP_POSITION.LEFT }, { children: [_jsx("b", { children: lockedBy || '' }), lockedTooltip] })), _jsx(Icons, { icon: E_ICONS.LOCK, color: COLORS.RED['500'], className: styles.lockIcon })] })) : (_jsx(Icons, { icon: E_ICONS.ARROW_RIGHT, color: COLORS.PRIMARY['500'] })) }))] })));
};
